import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import styles from './ForCompanyPage.module.scss';

const ForCompanyPage = () => (
    <Paper className={styles.paper}>
      <Typography variant="h4" className={styles.title}>Станьте нашим оптовым клиентом</Typography>
      <div className={styles.description}>
        Компания "Подзамену" работает на рынке автотоваров уже 12 лет, мы рады предложить Вам работу с нами в качестве
        надежного партнёра по постоянному обеспечению Вашего бизнеса на самых выгодных условиях. С нами Вы экономите
        бюджет и время.
      </div>
      <Typography variant="h4" className={styles.title}>Почему с нами удобно работать?</Typography>
      <Typography className={styles.chapter}>Работаем с НДС.</Typography>
      <ul>
        <li>
          Вы можете вернуть налог.
        </li>
      </ul>
      <Typography className={styles.chapter}>Выдача быстро и в любом удобном пункте.</Typography>
      <ul>
        <li>
          48 пунктов выдачи в 35 городах, и мы постоянно расширяем своё присутствие.
        </li>
      </ul>
      <Typography className={styles.chapter}>Предоставляем полный пакет документов.</Typography>
      <ul>
        <li>Коммерческое предложение, договор, счет, работаем в ЭДО.</li>
      </ul>
      <Typography className={styles.chapter}>Широчайший ассортимент.</Typography>
      <ul>
        <li>
          Только проверенные поставщики и десятки тысяч позиций новых запчастей.</li>
      </ul>
      <Typography className={styles.chapter}>Персональный менеджер.</Typography>
      <ul>
        <li>Индивидуальный подход и консультация опытного специалиста по подбору</li>
      </ul>
      <Typography className={styles.chapter}>Максимально быстро.</Typography>
      <ul>
        <li>Доставка нужных деталей от одного часа</li>
      </ul>
      <Typography variant="h4" className={styles.titleWithMargin}>Наши контакты:</Typography>
        <Typography className={styles.chapter}>+7 984 157 66 29</Typography>
        <Typography className={styles.chapter}>shop.podzamenu@yandex.ru</Typography>
    </Paper>
);

export default ForCompanyPage;
